<template>
  <preview-list @newPreview="newPreview" />
</template>

<script>
import PreviewList from '../components/fast-counter-list/PreviewList'
export default {
  components: {
    PreviewList
  },
  created () {
    this.$store.dispatch('fastCounter/clearState')
  },
  methods: {
    newPreview () {
      this.$router.push('/preview/new')
    }
  }
}
</script>
